import {isString} from "lodash"
import env from "../../../env"
import getUrlForEnv, {services} from "../../../endpoints/getUrlForEnv"

/** @author: Richard Scoones, 20/4/2018
 *  @desc: Support for localhost graphql'ing
 */
export default function getUrl({reqEUinstance}: {reqEUinstance?: boolean} = {}) {
  if (env.IS_LOCAL && env.GRAPH_QL === "v2") {
    return `http://${env.GET_LOCAL}:3001/v2`
  } else if (env.GRAPH_QL === "local" || env.IS_LOCAL) {
    return `http://${env.GET_LOCAL}:3001/v1`
  } else if (env.GRAPH_QL === "v2") {
    return getUrlForEnv(services.GRAPH_QL_SERVICE, "/v2", reqEUinstance)
  } else if (isString(env.GRAPH_QL) && env.GRAPH_QL.includes("http")) {
    return env.GRAPH_QL
  }

  return getUrlForEnv(services.GRAPH_QL_SERVICE, "/v1", reqEUinstance)
}
